import {Component, Input, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DomSanitizer} from '@angular/platform-browser';
import {AppColorList, ColorName} from 'app/entities/enums';


@Component({
  selector: 'app-counter',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class CounterComponent implements OnInit {
  @Input() public value: any;
  @Input() public backgroundType: AppColorList = 'primary';
  @Input() public foregroundType: AppColorList = 'white';
  @Input() public animation: boolean = false;
  @Input() public innerClass: string = '';
  @Input() public innerStyle: string = '';
  @Input() isShadow: boolean = false;

  constructor(
    private httpClient: HttpClient,
    private sanitizer: DomSanitizer,
  ) {
  }

  ngOnInit(): void {
  }

}
